export default "__VITE_ASSET__IRAMBl9F__"